import { RMH_UI_INTERFACE_ENABLED } from '../constants'

export const isRMHUiEnabled = () => {
  return localStorage.getItem(RMH_UI_INTERFACE_ENABLED) === 'true'
}
